module.exports = __webpack_public_path__ + "img/Vomp.5facc4f5.jpg";